import { render } from "./MenuExterno.vue?vue&type=template&id=87c4e416&scoped=true"
import script from "./MenuExterno.vue?vue&type=script&lang=js"
export * from "./MenuExterno.vue?vue&type=script&lang=js"

import "./MenuExterno.vue?vue&type=style&index=0&id=87c4e416&lang=scss&scoped=true"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/transparencia-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87c4e416"]])

export default __exports__